import { render, staticRenderFns } from "./ListCollapseButton.vue?vue&type=template&id=508e7f7a&"
import script from "./ListCollapseButton.vue?vue&type=script&lang=js&"
export * from "./ListCollapseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports